import { getExchange } from '../helpers';
import type { OrderItem } from '../../../graphql/query/getOrder';
import { rawString } from '../../Language/Language';
import type { WorkflowData } from '../../../workflow';
import type { ExtractedReason } from '../../../utils/item';
import type { ResolutionByItem } from '../../../hooks/useResolutions';

// Helper to compute the per-item data needed for rendering
export const buildItemSummary = (
  item: OrderItem | undefined,
  resolutionId: string,
  data: WorkflowData | null,
  reasonsByItem: Record<OrderItem['id'], ExtractedReason>,
  resolutionsByItem: Record<OrderItem['id'], ResolutionByItem>,
) => {
  if (!item) return null;

  const exchangeProps = getExchange(resolutionsByItem?.[item.id]);
  const selectedVariant = exchangeProps?.exchangeVariant;

  const reasonsForItem = reasonsByItem[item.id];
  const { selectedReason } = reasonsForItem ?? { selectedReason: undefined };
  const selectedResolution = resolutionId;

  // For review page, get the quantity from form data if available, otherwise use shipment logic
  const selectedQuantity = (() => {
    // First check if we have explicit quantity data for this item
    const itemData = data?.items?.[item.id];
    if (itemData?.itemSelection?.quantity) {
      return itemData.itemSelection.quantity;
    }

    // Fallback to item's remaining quantity (which should be correct for regular items)
    return item?.quantity?.remaining ?? 1;
  })();

  const additionalDetails = selectedQuantity
    ? [
        {
          name:
            rawString({ langKey: 'pdx.item_selection.quantity_label' }) ?? '',
          value: `${selectedQuantity}`,
        },
      ]
    : [];

  return {
    selectedVariant,
    selectedReason,
    selectedResolution,
    selectedQuantity,
    additionalDetails,
  };
};
